import { addStyles } from 'ethcss'
import { IStyles } from 'theme'

const styles: IStyles = {
    tabPanel: {
        minHeight: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
}

addStyles(styles)
export default styles
